var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"placeholder",attrs:{"data-external":"placeholder"}},[_c('h1',[_vm._v("Under development")])])
}]

export { render, staticRenderFns }